<template>
  <div>
    <template v-if="data && dataType === 'category'">
      <PageProductSearch :category="data" />
    </template>
    <template v-else-if="data && dataType === 'product'">
      <PageProduct :product="data" />
    </template>
    <!-- <pre>{{ data }}</pre> -->
    
  </div>
</template>

<script setup lang="ts">
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    ch_de: '/reinigungsprodukte/[...all]',
    ch_fr: '/produits-de-nettoyage/[...all]',
    ch_it: '/prodotti-per-la-pulizia/[...all]',
    ch_en: '/cleaning-products/[...all]',
    at_de: '/reinigungsprodukte/[...all]',
    at_en: '/cleaning-products/[...all]',
    de_de: '/reinigungsprodukte/[...all]',
    de_en: '/cleaning-products/[...all]',
    se_sv: '/stadprodukter/[...all]', // "ä" → "a"
    se_en: '/cleaning-products/[...all]',
    pl_pl: '/produkty-czyszczace/[...all]', // "czyszczące" → "czyszczace"
    pl_en: '/cleaning-products/[...all]',
  },
})

const route = useRoute()
const localePath = useLocalePath()
const params = route.params.all ? route.params.all.filter(Boolean) : []
const dataType = ref(params.includes('p') ? 'product' : 'category')

const data = ref(null)

if (params.length <= 1) {
  // Redirect to the category overview page if the route is incomplete
  navigateTo(
    localePath({
      name: 'products-all',
      params: { all: ['c', 'Chemie'] },
    }),
  )
}

function getShopwarePath() {
  if (dataType.value === 'category') {
    return `${params.join('/')}/`
  }

  // Remove each item that is before the "p" parameter
  const filteredParams = params.slice(params.indexOf('p'))

  return `${filteredParams.join('/')}`
}

try {
  const shopwarePath = getShopwarePath()

  switch (dataType.value) {
    case 'category': {
      const { fetchCategoryBySeoPath, category: categoryFetched } = useFetchCategoryBySeoPath()
      await fetchCategoryBySeoPath(shopwarePath)
      // Provide the category to the context
      const { category } = useCategory(categoryFetched)
      data.value = category
      break
    }
    case 'product': {
      const { fetchProductBySeoPath, product } = useFetchProductBySeoPath()
      await fetchProductBySeoPath(shopwarePath, {})
      data.value = product.value
      break
    }
    default:
      console.error('Unknown data type')
      break
  }
} catch (error) {
  console.error(error)
  throw createError({
    statusCode: 500,
    statusMessage: 'Shopware Error',
    message: `Could not fetch data from Shopware: ${error}`,
  })
}
</script>
